import { SubmissionError } from 'redux-form';

const knownError = (response, reject) =>
  response.json().then((value) => {
    const submissionError = new SubmissionError(value);
    reject(submissionError);
    throw submissionError;
  });

export default knownError;



// WEBPACK FOOTER //
// ./src/helpers/api/knownError.js